var lastRequest = null;

function requestUpdates(changeData, callback) {
    lastRequest = $.ajax({
        url: '/wp-admin/admin-ajax.php',
        type: 'POST',
        data: {
            action: 'megacase_ajax_update_case',
            changeData: JSON.stringify(changeData)
        },
    });

    lastRequest.fail( function( jqXHR, textStatus, errorThrown ) {

        megacase_remove_error_notes();
        megacase_show_error_note( 'Fehler beim abrufen der Flightcase Daten.' );
    });

    lastRequest.done(function (data, state, promise) {
        if (promise === lastRequest) {

            megacase_remove_error_notes();

            lastRequest = null;
            callback(data);
        }
    });
}

function megacase_show_error_note( error_text ) {
    ( function( $ ) {

        // set case as virtual = disable add to cart button
        $('.casefactory .summary form.cart').addClass('virtualCase');

        // get woocommerce notice section
        let wc_info_div = $( ".site-content > .col-full > .woocommerce" );

        // show error note
        wc_info_div.append( '<div class="woocommerce-error mc-error">' + error_text + ' <a href="">Seite neu laden</a></div>' );

    } )( jQuery );
}

function megacase_remove_error_notes() {
    ( function( $ ) {

        // set case as not virtual = enable add to cart button
        $('.casefactory .summary form.cart').removeClass('virtualCase');

        // get prevoius added error note
        let wc_info_div = $( ".site-content > .col-full > .woocommerce > .woocommerce-error.mc-error" );
        wc_info_div.remove();

    } )( jQuery );
}

module.exports = requestUpdates;


// WEBPACK FOOTER //
// ./js/caseconfigurator/casefactory/lib/requestUpdates.js